import { render, staticRenderFns } from "./EditPlanWarn.vue?vue&type=template&id=8c936888&scoped=true"
import script from "./EditPlanWarn.vue?vue&type=script&lang=js"
export * from "./EditPlanWarn.vue?vue&type=script&lang=js"
import style0 from "./EditPlanWarn.vue?vue&type=style&index=0&id=8c936888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c936888",
  null
  
)

export default component.exports